// src/context/YearContext.js
import React, { createContext, useState, useEffect } from "react";

export const YearContext = createContext();

export const YearProvider = ({ children }) => {
  const [selectedYear, setSelectedYear] = useState(() => {
    return localStorage.getItem("selectedYear") || "2568";
  });

  useEffect(() => {
    localStorage.setItem("selectedYear", selectedYear);
  }, [selectedYear]);

  return (
    <YearContext.Provider value={{ selectedYear, setSelectedYear }}>
      {children}
    </YearContext.Provider>
  );
};
